import React, { useState } from 'react';

import { 
  Character,
  TransformOption2,
  CreatureInstance,
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";

import SelectTransformOption2Box from "@dndComponents/select/SelectTransformOption2Box";
import CharacterListOptionsInput from "@dndComponents/character/misc/CharacterListOptionsInput";

interface Props {
  name: string;
  value: TransformOption2 | null;
  character: Character | CreatureInstance;
  shared: boolean;
  option_list: TransformOption2[];
  index?: boolean;
  onChange: (selected: any) => void;
}

const common_util = CommonUtilities.getInstance();

export default function CharacterTransformOptions({
  name,
  value,
  character,
  option_list,
  shared,
  index,
  onChange
}: Props) {
  const [ping, setPing] = useState(false);
  const [change_time, setChangeTime] = useState(0);

  // debugger;
  if (index && character instanceof Character) {
    return (
      <CharacterListOptionsInput 
        data_type="spell"
        char={character}
        use_objects={option_list}
        selected={ value && value.creature ? [value.creature._id] : (value && value.custom_stat_block ? [value.custom_stat_block.true_id] : []) } 
        choose_max={1}
        change_time={change_time}
        onChange={(changed: string[]) => {
          // debugger;
          const id = changed[0];
          const obj_finder = option_list.find(o => o._id === id);
          if (obj_finder) {
            onChange(obj_finder);
            // setPing(!ping);
            setChangeTime(common_util.get_time_number());
          }
        }}
      />
    );
  } else {
    return (
      <SelectTransformOption2Box 
        name={name}
        options={option_list}
        value={ value ? (value.creature ? value.creature._id : value.custom_stat_block?.true_id??undefined) : undefined }
        onChange={(changed: string) => {
          const obj_finder = option_list.find(o => o._id === changed);
          if (obj_finder) {
            onChange(obj_finder);
            setPing(!ping);
          }
        }}
      />
    );
  }
}
